export function stableSerialize(value: unknown): string {
  return JSON.stringify(value);
}
